<script setup>
import { ref, onMounted } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head, useForm } from '@inertiajs/inertia-vue3';
import BaseIcon from "@/Components/BaseIcon.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import {
    mdiHomeSearch, mdiWhatsapp, mdiCashPlus,
    mdiCradle, mdiPuzzleRemove, mdiTownHall, mdiCross, mdiPill, mdiMedicalBag, mdiGymnastics, mdiWater, mdiCheckDecagram, mdiContentSave, mdiAccountSupervisor,
    mdiCreditCardOutline, mdiPlusCircle, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiMail, mdiInformationOutline, mdiPrinter, mdiFileDocumentMultipleOutline,
    mdiCardAccountDetails, mdiGenderMaleFemale, mdiCellphone, mdiEmail, mdiClockTimeFive
} from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableAdvancedFilter from "@/Components/TableAdvancedFilter.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import { Inertia } from '@inertiajs/inertia';
// Breeze
import BreezeButton from '@/Components/Button.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';


import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBoxCiclo from "@/Components/CardBoxCiclo.vue";
import RadarChart from "@/Components/Charts/RadarChart.vue";
import NotificationAlert from "@/Components/NotificationAlert.vue";
import VueSelect from "vue3-select-component";

/* - LRR defineProps({
    //students: Array,
    //columnas: Array,
    object: Object
});
*/
const props = defineProps({
    //students: Array,
    //columnas: Array,
    actioncontrol: {
        type: String,
        default: 'view'
    },
    object: Object,
    collaborators: Object,
    freeday_types: Object,
    user_modif: Object,
    canRead: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    back_link: String,
    debugInertia: Boolean,
    isAdmin: Boolean,

});


/* LRR
{
start: '2018-11-19 12:00', // Required.
end: '2018-11-19 14:00', // Required.
// Instead of formatted dates, you can also provide Javascript Date objects:
// start: new Date(2018, 11 - 1, 19, 12, 0),
// end: new Date(2018, 11 - 1, 19, 14, 0),
title: {String}, // Optional.
content: {String}, // Optional.
class: {String}, // Optional - space-separated css classes.
background: {Boolean} // Optional. (Event type not CSS property)
split: {Number|String} // Optional.
allDay: {Boolean} // Optional.
deletable: false // optional - force undeletable when events are editable.
resizable: false // optional - force unresizable when events are editable.
}
*/
const anioSearch = ref(null)

/* onMounted(() => {
    
}); */

//console.log(props.typeDocuments)
// Carga de objeto
const rutaPrefijo = ref('freeday')
const modulo = ref('freeday')
const modulos = ref('Días Libres')
const action = ref(props.actioncontrol) // Los props son de lectura así que en el template se haré cambios al action segúnn el click a cada boton

const tab = ref(0)

// deshabilitar o habilitar
const initModal = (action) => {
    let ruta = rutaPrefijo.value + '-' + action
    Inertia.put(route(ruta, {
        'id': props.object.id,
    }
    ))

}

const form = useForm({
    id: props.object ? props.object.id : 0,
    // Freeday
    //ref: props.object ? props.object.ref : null,
    //label: props.object ? props.object.label : null,
    description: props.object ? props.object.description : null,
    fecha_inicio: props.object ? props.object.fecha_inicio : '',
    fecha_fin: props.object ? props.object.fecha_fin : '',
    id_collaborator: props.object ? props.object.id_collaborator : null,
    id_freeday_type: props.object ? props.object.id_freeday_type : (props.isAdmin ? 1 : 2),
    status: props.object ? props.object.status : 1

});


// id => value y label => label
//const typeIGV = ref([{'id': 0, 'label': '0'}, {'id': 18, 'label': '18'}])

const clean = (origen = '') => {

    if (origen == 'product') {
        action.value = 'view'
    }

}

/**
 * 
 * LRR 
 * Incializar valorres
 */

/*
const optionsVivienda = [
    {id: 0, label: 'Casa propia'},
    {id: 1, label: 'Casa alquilada'},
    {id: 2, label: 'Casa de otros familiares'},
    {id: 3, label: 'Casa alquilada'},
    {id: 9, label: 'Otro :'},
]
*/

// Usar objecto de 
/*const json = '{"result":true, "count":42}';
const obj = JSON.parse(json);
Y
console.log(JSON.stringify({ x: 5, y: 6 }));
// expected output: "{"x":5,"y":6}"

console.log(JSON.stringify([new Number(3), new String('false'), new Boolean(false)]));
// expected output: "[3,"false",false]"

console.log(JSON.stringify({ x: [10, undefined, function(){}, Symbol('')] }));
// expected output: "{"x":[10,null,null,null]}"

console.log(JSON.stringify(new Date(2006, 0, 2, 15, 4, 5)));
// expected output: ""2006-01-02T15:04:05.000Z""

//const objVivienda[{"attribute_type_id":"5024","description":"Asientos","value":"20","start_date":null,"end_date":null,"duration":null}]
*/

// Crear o actualizar
const submit = () => {
    if (action.value == 'create') {
        form.post(route(rutaPrefijo.value + '-registrar'), {
            //onFinish: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
            onSuccess: () => form.reset('ref', 'label', 'description', 'price', 'cost_price', 'id_talla'),
        });
    } else {
        form.put(route(rutaPrefijo.value + '-actualizar'), {
            onFinish: () => {
                form.reset('ref, label, description, price, cost_price, id_talla, tosell')
                clean('product')
            },
            onError: () => window.Toast.error(errors.create)
        });
    }

};



//const cancel = () => {
//if (rutaPrefijo.value=='student') {
//form.obs_aprendizaje = '';
//}
//}

const formatDate = (date) => {
    //var now = new Date().toLocaleDateString()
    var date = new Date(date)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
    return result
}

//console.log(props.object)
const formatDateTime = (datetime) => {
    var date = new Date(datetime)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
    return result
}



/**
 * Section Alert
 */

const isAlertActive = ref(false)
const isAlertDangerActive = ref(false)
const messageAlert = ref('')
/* const error = ref(0)
const errors = ref([]) */
const colorAlert = ref('success')
const errormsg = ref(null)
const errors = ref(0)
const alertIndex = ref(0)

const showAlert = (message, color, time = 1) => {

    messageAlert.value = message
    colorAlert.value = color

    isAlertActive.value = true

    /* if (color == 'danger') {
        isAlertDangerActive.value = true
    } else {
        isAlertActive.value = true
    } */
    setTimeout(() => {
        isAlertActive.value = false
        /* if (color == 'danger') {
            isAlertDangerActive.value = false
        } else {
            isAlertActive.value = false
        } */
        errormsg.value = ref(null)
        errors.value = ref(0)
        alertIndex.value = ref(0)
        //isActionMassive.value = false
    }, time * 1000)// LRR bind(this)


}

const backLink = ref(props.back_link ? '/#' + props.back_link : '')

</script>

<template>

    <Head :title="object ? object.ref + ' ' + object.label : 'Nuevo Día Libre'" />

    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />

    <BreezeAuthenticatedLayout>
        <!-- <template #header>
            <div class="flex justify-between items-center">
                <div>
                    <div v-if="action != 'create'" class="flex flex-wrap tab-m">
                        <button @click="(tab = 0), (action = 'view')" class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab == 0 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Día Libre</span>
                        </button>
                    </div>
                    <div v-else>
                        <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Nuevo Día Libre</span>
                    </div>
                </div>
            </div>
        </template> -->

        <template #header>
            <div class="min-h-[73px] flex justify-between">
                <div v-if="action != 'create'" class="navigation-menu">
                    <button @click="(tab = 0), (action = 'view')" :class="[tab == 0 ? 'active' : 'inactivo']">
                        <div>Productos</div>
                    </button>
                    <!-- <button @click="(tab = 1), (action = 'stock')"
                            class="relative border lg:border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-1 px-2 lg:py-2 lg:px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0"
                            :class="[tab == 1 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                            <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Contacto/Apoderado</span>
                        </button> -->
                </div>
                <div class="min-h-[73px] flex justify-center flex-col">
                    <h2 class="font-semibold text-sm lg:text-base text-gray-800 leading-tight">
                        Nuevo Día Libre
                    </h2>
                    <!-- <p class="text-xs lg:text-sm"> UBICAR AQUI DESCRIPCIÓN</p> -->
                </div>
            </div>

            <BreezeValidationErrors class="mb-4 mt-4" />

            <!-- In basebutton: @click="route('dashboard')"-->

            <!--<Link :href="route('student-create')">
        <BaseButton
            color="info"
            :icon="mdiPlusCircle"
            small
            label=" Nuevo"
            class="ml-2 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
        />
    </Link>

    <a href="/public/studentcreate" target="_blank">
        <BaseButton
            color="info"
            :icon="mdiPlusCircle"
            small
            label=" Registro público"
            class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
        />
    </a>-->
        </template>



        <div>


            <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

            <template v-if="(tab == 0)">
                <template v-if="action == 'view' && object">
                    <div class="grid grid-cols-1 gap-4 mb-4">
                        <div class="col-span-1 bg-white rounded-lg shadow-lg p-6 h-full my-auto">
                            <div class="grid grid-cols-1 md:flex flex-row gap-4 h-full">
                                <div class="col-span-1 h-auto my-auto">
                                    <img class="max-h-32 lg:max-h-36 rounded-lg border-2 border-gray-600 shadow-xl" :src="object.url ? '/img/dashboard/bg-popup.png' : '/img/dashboard/bg-popup.png'">
                                </div>
                                <div class="col-span-1 h-auto my-auto">
                                    <div class="flex items-center h-full justify-start">

                                        <div>
                                            <span class="text-2xl font-bold">{{
                                                object.label
                                            }}</span><br>
                                            <span class="font-bold mr-2">Descripción : </span>{{ object.description }}
                                            <br>

                                            <span class="font-bold mr-2">Precio sin impuesto : </span> {{ object.price }}<br>
                                            <span class="font-bold mr-2">Precio incluido IGV : </span> {{
                                                object.price_ttc
                                            }}, IGV Tasa : {{ object.tva_tx }}<br>
                                            <!-- <span class="font-bold mr-2">Talla : </span>{{ object.id_talla ? tallas.find(item => item.id === object.id_talla).label : '' }}
                                                <br> -->
                                            <span class="font-bold mr-2">Stock : </span>
                                            {{ object.stock }}<br>
                                            <span class="font-bold mr-2">En Venta : </span>{{ object.tosell ?
                                                'Si' :
                                                'No'
                                            }}<br>
                                            <!-- Referencia : {{ object.person.referencia }} -->
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- Modificar -->
                    <div v-if="canWrite" class="flex flex-row-reverse w-full">
                        <!-- Aceso desde AdminCoord -->
                        <!-- <div class="grid md:cols-1 lg:grid-cols-8 gap-4">
                                        <div class="rounded-lg bg-white shadow-lg p-6 col-span-3 grid lg:col-start-6 gap-4">
                                            <div class="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                                                <div class="col-span-1">
                                                    <BaseButton color="warning" :icon="mdiPencil" @click="action = 'edit'"
                                                        label=" Modificar" class="w-full" />
                                                </div>
                                                <div class="col-span-1">
                                                    <BaseButton v-if="object.status" color="danger"
                                                        @click="initModal('desactivar')" label="Deshabilitar (retirado)" class="w-full" />
                                                    <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                                        @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                        <!-- BOTONES -->
                        <!-- BOTONES -->
                        <div class="rounded-lg bg-white shadow-lg p-6 gap-4 lg:w-auto w-full">
                            <div class="grid grid-cols-1 md:grid-cols-2 lg:flex flex-row gap-4">
                                <!-- <-- cols-4 para cuatro botones o 3  -->
                                <!-- <div class="col-span-1">
                                                <BaseButton color="info" :icon="mdiPencil"
                                                    label=" Modificar" class="w-full" />
                                            </div>
                                            <div class="col-span-1">
                                                <BaseButton color="success" :icon="mdiPencil" 
                                                    label=" Modificar" class="w-full" />
                                            </div> -->
                                <div class="col-span-1">
                                    <BaseButton color="warning" :icon="mdiPencil" @click="action = 'edit'" label=" Modificar" class="w-full" />
                                </div>
                                <!-- <div class="col-span-1">
                                        <BaseButton v-if="object.status" color="danger" @click="initModal('desactivar')"
                                            label="Deshabilitar (retirado)" class="w-full" />
                                        <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                            @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                    </div> -->
                            </div>
                        </div>
                    </div>
                </template>
                <!-- Editar -->
                <template v-else-if="action == 'edit' && canWrite">
                    <div class="grid grids-col-1 bg-white rounded-lg shadow-lg p-6 ">
                        <h3 class="md:text-2xl text-xl my-4 font-bold">Modificar</h3>
                        <form @submit.prevent="submit">
                            <FormField label="Etiqueta nombre / talla">
                                <!-- <FormControl v-model="form.ref" name="ref" type="text" required /> -->
                                <FormControl v-model="form.label" name="label" type="text" required />
                                <FormControl v-model="form.id_talla" type="select" :options="tallas" />
                            </FormField>
                            <FormField label="Descripción">
                                <FormControl v-model="form.description" type="textarea" />
                            </FormField>
                            <FormField label="Estado">
                                <FormControl v-model="form.tosell" type="yesno" placeholder="en venta" />
                                <FormControl v-model="form.tobuy" type="yesno" placeholder="en compra" />
                                <FormControl v-model="form.cost_price" type="number" placeholder="Precio de costo" title="Precio de costo" />
                            </FormField>
                            <FormField label="Precio">
                                <FormControl v-model="form.price" type="number" :set="(form.price = (form.price_ttc / (1 + (form.tva_tx / 100))))" labelinput="Precio Sin impuesto" readonly />
                                <FormControl v-model="form.tva_tx" type="select" :options="optionsIgvTasa" labelinput="Tasa IGV" />
                                <FormControl v-model="form.price_ttc" type="number" labelinput="Precio incluido IGV" />
                            </FormField>
                            <FormField label="Stock">
                                <!-- <FormControl v-model="form.stock" type="number" labelinput="Stock Inicial" /> -->
                                <FormControl v-model="form.stock_alerta" type="number" labelinput="Stock mínimo para alerta" />

                            </FormField>

                            <div class="flex items-center justify-end mt-4">
                                <!--<Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Already registered?
                                            </Link>-->
                                <!-- <BreezeButton @click="(action='view')" class="ml-4">
                                                Cancelar
                                            </BreezeButton> -->
                                <Link :href="route('product-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                </Link>

                                <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                    Actualizar
                                </BreezeButton>
                            </div>
                        </form>
                    </div>
                </template>
                <!-- Crear sólo desde el botón return dashboard-->
                <template v-else-if="action == 'create'">
                    <div class="grid grid-cols-1 bg-white rounded-md shadow-lg p-4 border ">
                        <ul>
                            <li>Para las peticiones de días libres de un sólo día, la fecha de inicio y de fin es el mismo día.</li>
                        </ul>
                        <div class="col-span-1">
                            <h3 class="md:text-2xl text-xl my-4 font-bold">Nueva Petición de Días Libres</h3>

                            <form @submit.prevent="submit">
                                <FormField label="Colaborador / Tipo de día libre" addclassad="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-3">
                                    <!-- <FormControl v-model="form.ref" name="ref" type="text" required /> -->
                                    <!-- <FormControl v-model="form.label" name="label" type="text" required /> -->

                                    <VueSelect class="select-search-light " v-model="form.id_collaborator" :options="collaborators" :get-option-label="(option) => `${option.apellidos} ${option.nombres}`" :placeholder="(isAdmin ? 'Todos' : 'Seleccione un colaborador')" required />


                                    <FormControl v-model="form.id_freeday_type" type="select" :options="freeday_types" required class="mb-0" />


                                </FormField>
                                <FormField label="Periodo">
                                    <FormControl v-model="form.fecha_inicio" type="date" labelinput="Fecha Inicio" required />
                                    <FormControl v-model="form.fecha_fin" type="date" labelinput="Fecha Fin" required />
                                </FormField>
                                <FormField label="Descripción">
                                    <FormControl v-model="form.description" type="textarea" placeholder="Alguna descripción (Opcional)" />
                                </FormField>



                                <div class="flex flex-col lg:flex-row justify-end items-center mt-4 gap-3">
                                    <div class="w-full lg:w-auto">
                                        <span v-if="!form.id_collaborator && isAdmin" class="font-medium text-blue-600">Se aplicará a todos los
                                            colaboradores activos</span>
                                    </div>
                                    <div class="w-full lg:w-auto">

                                        <Link :href="route('freeday-list')">
                                            <BreezeButton type="button">
                                                Cancelar
                                            </BreezeButton>
                                        </Link>
                                    </div>
                                    <div class="w-full lg:w-auto" v-if="!form.fecha_inicio || !form.fecha_fin">
                                        <span class="font-medium text-red-600">Debe seleccionar un periodo</span>
                                    </div>
                                    <div class="w-full lg:w-auto" v-else>
                                        <BreezeButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                            {{ isAdmin ? 'Registrar y Aprobar' : 'Registrar en espera de aprobación' }}
                                        </BreezeButton>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </template>

            </template>
        </div>




    </BreezeAuthenticatedLayout>
</template>
